import styled from "styled-components";
import React from "react";

const Container = styled.div`
    color: #bd2d2d;
    font-size: 12px;
    line-height: 22px;
`;

export const PartialUpdateWarning = ({actualPercentage, requestedPercentage}) => {
    if (actualPercentage === requestedPercentage) return null;

    return <Container className="t-partial-update-warning">Investment change limited by portfolio rules</Container>;
};